import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-lg-row flex-column-fluid",
  style: {"background-image":"url('/media/illustrations/bg10.jpeg')"}
}
const _hoisted_2 = { class: "d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12" }
const _hoisted_3 = { class: "bg-body d-flex flex-column flex-center rounded-4 w-md-600px p-10" }
const _hoisted_4 = { class: "d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-400px" }
const _hoisted_5 = { class: "d-flex flex-center flex-column-fluid pb-15 pb-lg-15" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-11" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/logos/fedup.png",
    class: "h-100px mb-6"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-fdp-blue fw-bolder mb-3" }, "Validación de credenciales"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fw-bold fs-6" }, " Acceso al sistema ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row g-3 mb-9 d-none" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "Logo",
        src: "/metronic8/demo1/assets/media/svg/brand-logos/google-icon.svg",
        class: "h-15px me-3"
      }),
      /*#__PURE__*/_createTextVNode(" Sign in with Google ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "Logo",
        src: "/metronic8/demo1/assets/media/svg/brand-logos/apple-black.svg",
        class: "theme-light-show h-15px me-3"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        alt: "Logo",
        src: "/metronic8/demo1/assets/media/svg/brand-logos/apple-black-dark.svg",
        class: "theme-dark-show h-15px me-3"
      }),
      /*#__PURE__*/_createTextVNode(" Sign in with Apple ")
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-content my-7" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-125px text-gray-500 fw-semibold fs-7" }, "***")
], -1)
const _hoisted_9 = { class: "fv-row mb-8 fv-plugins-icon-container" }
const _hoisted_10 = { class: "fv-row mb-3 fv-plugins-icon-container" }
const _hoisted_11 = { class: "d-flex flex-stack flex-wrap gap-3 fs-base fw-bold mb-8" }
const _hoisted_12 = { class: "d-grid mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Ingresar ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Espere un momento... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-light-info text-gray-600 bg-light mb-0",
  role: "alert"
}, [
  /*#__PURE__*/_createTextVNode(" Si tuviera algún inconveniente técnico con la plataforma, puede comunicarse al correo: "),
  /*#__PURE__*/_createElementVNode("b", null, "soporte@perufedup.com")
], -1)
const _hoisted_17 = { class: "d-flex flex-stack" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"me-10 d-flex gap-5\"><a href=\"https://www.facebook.com/perufedup/\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-facebook-f\"></i></a><a href=\"https://twitter.com/perufedup\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-twitter\"></i></a><a href=\"https://www.instagram.com/perufedup/\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-instagram\"></i></a><a href=\"https://pe.linkedin.com/company/perufedup\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-linkedin-in\"></i></a></div>", 1)
const _hoisted_19 = { class: "d-flex text-primary fs-base gap-5" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "text-muted" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-lg-row-fluid d-none d-sm-none d-md-block\"><div class=\"d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100\"><img class=\"theme-light-show mx-auto mw-100 w-150px w-lg-300px mb-10 mb-lg-20\" src=\"/media/illustrations/tramite.jpg\" alt=\"\"><h1 class=\"text-gray-800 fs-2qx fw-bold text-center mb-7\"> Mesa de Partes Virtual </h1><div class=\"text-gray-600 fs-base text-center fw-semibold\"> ¡Bienvenido a nuestra Mesa de Partes Virtual! Aquí podrás realizar <br>tus trámites y solicitudes de manera rápida y eficiente, <br> sin necesidad de acudir físicamente a nuestras instalaciones. </div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_DialogPassReset = _resolveComponent("DialogPassReset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form, {
              ref: "ruleFormRef",
              model: _ctx.form,
              rules: _ctx.rules,
              class: "w-100"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_form_item, { prop: "username" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
                        "prefix-icon": _ctx.User,
                        size: "large",
                        placeholder: "Usuario",
                        maxlength: "30"
                      }, null, 8, ["modelValue", "prefix-icon"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_form_item, { prop: "password" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                        "prefix-icon": _ctx.Key,
                        onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onSubmitLogin(_ctx.ruleFormRef)), ["enter"])),
                        "show-password": "true",
                        size: "large",
                        placeholder: "Contraseña"
                      }, null, 8, ["modelValue", "prefix-icon"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    to: "/sign-up",
                    class: "link-primary fs-6 fw-bold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Crear una cuenta ")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open_modal_passreset=true)),
                    class: "link-primary fs-6 fw-bold"
                  }, " Recuperar contraseña ? ")
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    ref: "submitButton",
                    class: "btn btn-lg btn-primary w-100 mb-5",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubmitLogin(_ctx.ruleFormRef)))
                  }, _hoisted_15, 512)
                ]),
                _hoisted_16
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("a", {
                href: _ctx.terms,
                target: "_blank"
              }, "Terms", 8, _hoisted_20),
              _createElementVNode("span", _hoisted_21, "versión " + _toDisplayString(_ctx.version), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_22,
    _createVNode(_component_DialogPassReset)
  ]))
}